import Util from "../util";
import { getTempInfo } from "../common.js";

/* 组合表现信息 */
const superFundProductIncomeAction = (data) => {
  return {
    type: "SUPERFUND_PRODUCT_INCOME",
    data,
  };
};

export const superFundProductIncomeDelAction = (data) => {
  return {
    type: "SUPERFUND_PRODUCT_INCOME_DEL",
    data,
  };
};

/* 业绩走势及基线折线图数据 */
const LineDataAction = (data) => {
  return {
    type: "LINE_DATA",
    data,
  };
};
export const LineDataDelAction = (data) => {
  return {
    type: "LINE_DATA_DEL",
    data,
  };
};

/* 最新业绩走势 */
const lineDataLast = (data) => {
  return {
    type: "LINE_DATA_LAST",
    data,
  };
};

export const lineDataLastDel = (data) => {
  return {
    type: "LINE_DATA_LAST_DEL",
    data,
  };
};

/* 详情页面信息 */
const strategiesDetails = (data) => {
  return {
    type: "STRATEGIES_DETAILS",
    data,
  };
};
export const strategiesDetailsDel = (data) => {
  return {
    type: "STRATEGIES_DETAILS_DEL",
    data,
  };
};

/* 累计收益折线图数据 */
const userAllIncomeHistory = (data) => {
  return {
    type: "USER_ALL_INCOME_HISTORY",
    data,
  };
};
export const userAllIncomeHistoryDel = (data) => {
  return {
    type: "USER_ALL_INCOME_HISTORY_DEL",
    data,
  };
};

/* 最新累计收益 */
const allIncomeLast = (data) => {
  return {
    type: "ALL_INCOME_LAST",
    data,
  };
};

export const allIncomeLastDel = (data) => {
  return {
    type: "ALL_INCOME_LAST_DEL",
    data,
  };
};

/* 调仓记录列表 */
const changeFundList = (data) => {
  return {
    type: "CHANGE_FUND_LIST",
    data,
  };
};
export const changeFundListDel = (data) => {
  return {
    type: "CHANGE_FUND_LIST_DEL",
    data,
  };
};

/* 获取非止盈未投基本表现信息及业绩走势折线图数据 */
export const getSuperFundProductIncome = (params, callBack) => {
  //params.superFundCode = "SF00l0";

  return async (dispatch, getState) => {
    const successCallback = async (succ) => {
      if (succ && succ.code === "0000") {
        console.log("successful");
        if (params.periodType == 1) {
          dispatch(superFundProductIncomeAction(succ.content));
        }
        let { incomeDateList: xData, incomeList4Benchmark: baseData, incomeList: data, incomeDateList4Benchmark: xBase } = succ.content;

        if (!xData) {
          xData = [];
          data = [];
        }
        if (!xBase) {
          xBase = [];
          baseData = [];
        }
        const xDataN = [...new Set([...xData, ...xBase])].sort();
        if (xDataN.length) {
          const lastData = xDataN[xDataN.length - 1];
          const incomeIndex = xData.indexOf(lastData);
          const lastIncome = incomeIndex != -1 ? data[incomeIndex] : "";
          const baseIndex = xData.indexOf(lastData);
          const lastBase = baseIndex != -1 ? baseData[baseIndex] : "";
          dispatch(lineDataLast({ lastBase, lastIncome }));
        }
        dispatch(
          LineDataAction({
            [params.periodType]: {
              incomeDateList: succ.content.incomeDateList,
              incomeList: succ.content.incomeList,
              incomeList4Benchmark: succ.content.incomeList4Benchmark,
              incomeDateList4Benchmark: succ.content.incomeDateList4Benchmark,
            },
          })
        );
        callBack && callBack(succ.content);
      } else {
        console.log("后台返回数据有误！" + succ.message);
      }
    };
    const errorCallback = (err) => {
      console.log(err);
    };
    Util.get(Util.url + "/api/v1/superfund/product/income/getProductIncomeHistory", params, successCallback, errorCallback);
  };
};

/* 非止盈-未投详情页面数据 */
export const getStrategiesDetails = (params, callback) => {
  //params.superFundCode = "SF0430";
  return (dispatch, getState) => {
    // dispatch(strategiesDetailsDel())
    const successCallback = (succ) => {
      if (succ && succ.code === "0000") {
        console.log("successful");
        const seriesData = succ.content.superFundBasicInfo.superFundItemFund4StyleTypeList.map((v, i) => {
          return {
            value: v.totalRate,
            name: `${v.styleTypeName.replace('基金','')}${Util.toPercent(v.totalRate)}`,
          };
        });
        const legendData = succ.content.superFundBasicInfo.superFundItemFund4StyleTypeList.map((v, i) => {
          return `${v.styleTypeName.replace('基金','')}${Util.toPercent(v.totalRate)}`;
        });
        succ.content.superFundBasicInfo.seriesData = seriesData;
        succ.content.superFundBasicInfo.legendData = legendData;
        dispatch(strategiesDetails(succ.content));
        callback && callback(succ.content);
      } else {
        console.log("后台返回数据有误！" + succ.message);
      }
    };
    const errorCallback = (err) => {
      console.log(err);
    };
    Util.get(Util.url + "/api/v1/superfund/product/nonStopProfit/getProductDetail", params, successCallback, errorCallback);
  };
};

/* 非止盈-已投详情页面数据 */
export const getStrategiesDetailsHaveCast = (params, rulse) => {
  //params.superFundCode = "SF0430";
  return async (dispatch, getState) => {
    // dispatch(strategiesDetailsDel())
    const token = await getTempInfo("shortToken");
    const successCallback = (succ) => {
      if (succ && succ.code === "0000") {
        console.log("successful");
        const seriesData = succ.content.superFundUserShare.fundItems.map((v, i) => {
          return {
            value: v.totalRate,
            name: `${v.styleTypeName}${Util.toPercent(v.totalRate)}`,
          };
        });
        const legendData = succ.content.superFundUserShare.fundItems.map((v, i) => {
          return `${v.styleTypeName}${Util.toPercent(v.totalRate)}`;
        });
        succ.content.superFundUserShare.seriesData = seriesData;
        succ.content.superFundUserShare.legendData = legendData;
        dispatch(strategiesDetails(succ.content));
        rulse && rulse(succ.content);
      } else {
        console.log("后台返回数据有误！" + succ.message);
      }
    };
    const errorCallback = (err) => {
      console.log(err);
    };
    params.token = token;
    Util.get(Util.url + "/api/v1/superfund/holdshare/nonStopProfit/getUserHoldShareDetail", params, successCallback, errorCallback);
  };
};

/* 获取止盈未投详情页面数据 */
export const getStrategiesDetailsStop = (params, callback) => {
  // params = {
  //   superFundCode: "SF10A1",
  // };
  return (dispatch, getState) => {
    const successCallback = (succ) => {
      if (succ && succ.code === "0000") {
        console.log("successful");
        const seriesData = succ.content.superFundBasicInfo.superFundItemFund4StyleTypeList.map((v, i) => {
          return {
            value: v.totalRate,
            name: `${v.styleTypeName}${Util.toPercent(v.totalRate)}`,
          };
        });
        const legendData = succ.content.superFundBasicInfo.superFundItemFund4StyleTypeList.map((v, i) => {
          return `${v.styleTypeName}${Util.toPercent(v.totalRate)}`;
        });
        succ.content.superFundBasicInfo.seriesData = seriesData;
        succ.content.superFundBasicInfo.legendData = legendData;
        dispatch(strategiesDetails(succ.content));
        callback && callback(succ.content);
      } else {
        console.log("后台返回数据有误！" + succ.message);
      }
    };
    const errorCallback = (err) => {
      console.log(err);
    };
    Util.get(Util.url + "/api/v1/superfund/product/stopProfit/getProductDetail", params, successCallback, errorCallback);
  };
};

/* 获取止盈已投详情页面数据 */
export const getStrategiesDetailsStopHaveCast = (params, rulse) => {
  //params.superFundCode = "SF10A1";

  return async (dispatch, getState) => {
    const token = await getTempInfo("shortToken");
    const successCallback = (succ) => {
      if (succ && succ.code === "0000") {
        console.log("successful");
        const seriesData = succ.content.superFundUserShare.fundItems.map((v, i) => {
          return {
            value: v.totalRate,
            name: `${v.styleTypeName}${Util.toPercent(v.totalRate)}`,
          };
        });
        const legendData = succ.content.superFundUserShare.fundItems.map((v, i) => {
          return `${v.styleTypeName}${Util.toPercent(v.totalRate)}`;
        });
        succ.content.superFundUserShare.seriesData = seriesData;
        succ.content.superFundUserShare.legendData = legendData;
        dispatch(strategiesDetails(succ.content));
        rulse && rulse(succ.content);
      } else {
        console.log("后台返回数据有误！" + succ.message);
      }
    };
    const errorCallback = (err) => {
      console.log(err);
    };
    params.token = token;
    Util.get(Util.url + "/api/v1/superfund/holdshare/stopProfit/getUserHoldShareDetail", params, successCallback, errorCallback);
  };
};

/* 获取调仓记录列表数据 */
export const getChangeFundList = (params) => {
  //params.superFundCode = "SF0430";
  return (dispatch, getState) => {
    const successCallback = (data) => {
      if (data && data.code === "0000") {
        let result = {};
        data.content.forEach((v) => {
          v.adjustDateStr = v.effectDateStr;
          v.adjustDate = v.effectDate;
          const key = v.adjustDateStr.split("-")[0];
          if (result[key]) return result[key].push(v);
          result[key] = [v];
        });
        dispatch(changeFundList({ adjustmentList: data.content, processedData: result }));
      } else {
        console.log("后台返回数据有误！" + data.message);
      }
    };
    const errorCallback = (err) => {
      console.log(err);
    };
    Util.get(Util.url + "/api/v1/superfund/product/adjustment/geSuperFundAdjustmentList", params, successCallback, errorCallback);
  };
};

/* 获取累计收益折线图 */
export const getHistoryIncomeList = (params) => {
  // params.superFundCode = "SF10A5";
  return async (dispatch, getState) => {
    const token = await getTempInfo("shortToken");
    const successCallback = (data) => {
      if (data && data.code === "0000") {
        // if (params.periodType == 1) {
        const lastAllIncome = data.content.incomeList[data.content.incomeList.length - 1];
        lastAllIncome && dispatch(allIncomeLast(lastAllIncome));
        // }
        dispatch(
          userAllIncomeHistory({
            [params.periodType]: {
              incomeDateList: data.content.incomeDateList,
              incomeList: data.content.incomeList,
            },
          })
        );
      } else {
        console.log("后台返回数据有误！" + data.message);
      }
    };
    const errorCallback = (err) => {
      console.log(err);
    };
    params.token = token;
    Util.get(Util.url + "/api/v1/superfund/holdshare/income/getUserAllIncomeHistory", params, successCallback, errorCallback);
  };
};

/* 获取已投业绩走势折线图数据 */
export const getUserTransactionIncomeAndProductIncome = (params) => {
  // params.superFundCode = "SF0430";
  return async (dispatch, getState) => {
    const token = await getTempInfo("shortToken");
    const successCallback = (succ) => {
      if (succ && succ.code === "0000") {
        // if (params.periodType == 1) {
        let { incomeDateList: xData, incomeList4Benchmark: baseData, incomeList: data, incomeDateList4Benchmark: xBase } = succ.content;

        if (!xData) {
          xData = [];
          data = [];
        }
        if (!xBase) {
          xBase = [];
          baseData = [];
        }
        const xDataN = [...new Set([...xData, ...xBase])].sort();
        const lastData = xDataN[xDataN.length - 1];
        const incomeIndex = xData.indexOf(lastData);
        const lastIncome = incomeIndex != -1 ? data[incomeIndex] : "";
        const baseIndex = xBase.indexOf(lastData); 
        const lastBase = baseIndex != -1 ? baseData[baseIndex] : "";
        dispatch(lineDataLast({ lastBase, lastIncome }));

        const buyListTemp = succ.content.buyDateList && succ.content.buyDateList.map((v) => v.split("-").join("/"));
        const sellListTemp = succ.content.redeemDateList && succ.content.redeemDateList.map((v) => v.split("-").join("/"));
        dispatch(
          LineDataAction({
            [params.periodType]: {
              incomeDateList: succ.content.incomeDateList,
              incomeList: succ.content.incomeList,
              incomeList4Benchmark: succ.content.incomeList4Benchmark,
              incomeDateList4Benchmark: succ.content.incomeDateList4Benchmark,
              buyList: buyListTemp,
              sellList: sellListTemp,
            },
          })
        );
      } else {
        console.log("后台返回数据有误！" + succ.message);
      }
    };
    const errorCallback = (err) => {
      console.log(err);
    };
    params.token = token;
    Util.get(Util.url + "/api/v1/superfund/holdshare/income/getProductIncomeAndUserTradeDate", params, successCallback, errorCallback);
  };
};

/* 获取策略指标数据 */
export const getEvaluationIndicator = (params, sucCallback) => {
  // params.superFundCode = "SF00l0";
  return (dispatch, getState) => {
    const successCallback = (succ) => {
      if (succ && succ.code === "0000") {
        sucCallback && sucCallback(succ.content);
      } else {
        console.log("后台返回数据有误！" + succ.message);
      }
    };
    const errorCallback = (err) => {
      console.log(err);
    };
    Util.get(Util.url + "/api/v1/superfund/product/evaluation/getEvaluationIndicator", params, successCallback, errorCallback);
  };
};



// WEBPACK FOOTER //
// ./src/action/portfolioAction.js